import { render, staticRenderFns } from "./addSetmeal.vue?vue&type=template&id=7d2efdde&scoped=true"
import script from "./addSetmeal.vue?vue&type=script&lang=ts"
export * from "./addSetmeal.vue?vue&type=script&lang=ts"
import style0 from "./addSetmeal.vue?vue&type=style&index=0&id=7d2efdde&prod&lang=css"
import style1 from "./addSetmeal.vue?vue&type=style&index=1&id=7d2efdde&prod&lang=scss"
import style2 from "./addSetmeal.vue?vue&type=style&index=2&id=7d2efdde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2efdde",
  null
  
)

export default component.exports